import {
  Box,
  Grid,
  Typography
} from '@mui/material';

const Stats = ({value, title}) => {
  return (
    <Grid item xs={12} md={4}>
      <Box textAlign="center" px={2}>
        <Typography variant="h3" sx={{ mt: 2, mb: 1 }}>{value}</Typography>
        <Typography variant="body1" sx={{ mt: 2, mb: 1 }}>{title}</Typography>
      </Box>
    </Grid>
  )
}

export default Stats;
